module.exports = __webpack_public_path__ + "static/media/portfolio5.b3205462.jpg";